import React, { FC } from 'react';

import { DFARegistrationForm } from 'Modules/business/registration';

import { Main } from '../../components/ui/main';


export const Onboarding: FC = () => (
    <Main>
        <DFARegistrationForm />
    </Main>
);
